// theme.js
import { createTheme } from "@mui/material/styles";

const theme = createTheme({
  palette: {
    primary: {
      main: "#5A9D5F", // green
    },
    secondary: {
      main: "#BF9450", // gold
      dark: "#a97e3d",
    },
    background: {
      default: "#F7F7F7",
      paper: "#FFFFFF",
    },
    text: {
      primary: "#707070",
    },
    custom: {
      beige: "#EBDDC6",
      white: "#FFFFFF",
      hover_white: "#F5F5F5",
      black: "#000000",
      gray: "#707070",
    },
  },
  typography: {
    fontFamily: '"Futura", "Helvetica", "Arial", sans-serif',
    h5: {
      fontWeight: 700,
      fontSize: "26px",
      color: "#5A9D5F",
    },
    body1: {
      fontSize: "20px",
      color: "#FFFFFF",
    },
    button: {
      textTransform: "none",
      fontWeight: 700,
      fontSize: "20px",
    },
  },
});

export default theme;
